<template>
    <program-info :program-info="getProgramInfo" />
</template>

<script setup lang="ts">
    import ProgramInfo from "@/components/ProgramInfo/ProgramInfo.vue";
    import { useHomePageStore } from "@/stores/HomePage";
    import { storeToRefs } from 'pinia';


    const HomePageStoreModule = useHomePageStore();
    const {
        getProgramInfo
    } = storeToRefs(HomePageStoreModule);
</script>
